import { memo } from 'react';

import type { RouteProps } from 'pkg/router/route';

/**
 * @todo not super nice with double Omit
 */
type IndexRouteProps = Omit<Omit<RouteProps, 'path'>, 'children'>;

export const IndexRoute = memo<IndexRouteProps>(() => null);
